import { DATA, snakeStore, SORT_COLUMN, SORT_DIRECTION } from '@app/plugins/vuex-async-pagginate';
import { DataBaseGroupService } from '@db/services/GroupService';

export const table = snakeStore(
  {
    state: {
      [SORT_COLUMN]: 'created_at',
      [SORT_DIRECTION]: 'desc'
    },
    actions: {
      getData: (_, params) => DataBaseGroupService.getList(params),
      updateItemById: ({ getters, commit }, value) => {
        commit(
          DATA,
          [...getters[DATA]].map(i => {
            return i.id === value.id ? { ...i, ...value } : i;
          })
        );
      }
    }
  },
  true
);
